import { Injectable } from '@angular/core';
import { DATicketStatus, TicketStatus } from 'src/app/models/enums';
import { IPlayedTicketState } from 'src/app/models/ticket/playedTicketState.interface';
import { IAffiliateBonusSetting } from '../models/bonus/affiliateBonusSetting.interface';
import { IBonusSettingDA } from '../models/bonus/DAObjects/bonusSettingDA.interface';
import { IPowerBonusDayDA } from '../models/bonus/DAObjects/powerBonusDayDA.interface';
import { IPowerBonusReportItemDA } from '../models/bonus/DAObjects/powerBonusReportItemDA.interface';
import { IPowerBonusSettingDA } from '../models/bonus/DAObjects/powerBonusSettingDA.interface';
import { IPowerBonusSettingItemDA } from '../models/bonus/DAObjects/powerBonusSettingItemDA.interface';
import { IWeeklyPowerBonusDA } from '../models/bonus/DAObjects/weeklyPowerBonusDA.interface';
import { IPowerBonusDayReport } from '../models/bonus/powerBonusDayReport.interface';
import { IPowerBonusReportItem } from '../models/bonus/powerBonusReportItem.interface';
import { IPowerBonusSetting } from '../models/bonus/powerBonusSetting.interface';
import { IPowerBonusSettingItem } from '../models/bonus/powerBonusSettingItem.interface';
import { IWeeklyPowerBonus } from '../models/bonus/weeklyPowerBonus.interface';
import { ICommissionEstimateReport } from '../models/commissions/commissionEstimateReport.interface';
import { ICommissionEstimateReportItem } from '../models/commissions/commissionEstimateReportItems.interface';
import { ICommissionReport } from '../models/commissions/commissionReport.interface';
import { ICommissionSetting } from '../models/commissions/commissionSetting.interface';
import { ICommissionSettingItem } from '../models/commissions/commissionSettingItem.interface';
import { ICommissionEstimateReportItemTO } from '../models/commissions/commissionsTO/commissionEstimateReportItemTO.interface';
import { ICommissionEstimateReportTO } from '../models/commissions/commissionsTO/commissionEstimateReportTO.interface';
import { ICommissionReportTO } from '../models/commissions/commissionsTO/commissionReportTO.interface';
import { ICommissionSettingItemTO } from '../models/commissions/commissionsTO/commissionSettingItemTO.interface';
import { ICommissionSettingTO } from '../models/commissions/commissionsTO/commissionSettingTO.interface';
import { IMessage } from '../models/messages/message.interface';
import { IMessageDA } from '../models/messages/messagesDA/messageDA.interface';
import { IMessagesForPageDA } from '../models/messages/messagesDA/messagesForPageDA.interface';
import { IMessagesForPage } from '../models/messages/messagesForPage.interface';
import { ISalesReportDA } from '../models/salesReport/DAObjects/salesReportDa.interface';
import { ISalesReportsByAffiliateDA } from '../models/salesReport/DAObjects/salesReportsByAffiliateDA.interface';
import { ISalesReport } from '../models/salesReport/salesReport.interface';
import { ISalesReportsByAffiliate } from '../models/salesReport/salesReportsByAffiliate.interface';
import { IAffiliateSetting } from '../models/settings/affiliateSetting.interface';
import { IAffiliateSettingDA } from '../models/settings/DAObjects/affiliateSettingDA.interface';
import { IAffiliatePlayedTicket } from '../models/ticket/affiliatePlayedTicket.interface';
import { IAffiliateTicketDA } from '../models/ticket/affiliateTicketDA.interface';
import { ITransaction } from '../models/transactions/transaction.interface';
import { ITransactionTO } from '../models/transactions/transactionTO.interface';
import { IAffiliate } from '../models/user/affiliate.interface';
import { IAffiliateSession } from '../models/user/affiliateSession.interface';
import { IBank } from '../models/user/bank.interface';
import { IAffiliateSessionTO } from '../models/user/transportedObjects/affiliateSessionTO.interface';
import { IAffiliateTO } from '../models/user/transportedObjects/affiliateTO.interface';
import { IBankTO } from '../models/user/transportedObjects/bankTO.interface';
import { CommissionReportsType, CommissionReportType, MessageStatus, PowerBonusSettingItemUpdateType, TicketTypeTM } from '../models/util/tmEnums';
import { IShopReportDA } from '../models/shopReport/DAObjects/shopReportDa.interface';
import { IShopReport } from '../models/shopReport/shopReport.interface';
import { IPaidReportsByAffiliateDA } from '../models/paidReport/DAObjects/paidReportsByAffiliateDA.interface';
import { IPaidReportsByAffiliate } from '../models/paidReport/paidReportsByAffiliate.interface';
import { IPaidReportDA } from '../models/paidReport/DAObjects/paidReportDa.interface';
import { IPaidReport } from '../models/paidReport/paidReport.interface';

@Injectable({
  providedIn: 'root'
})
export class ModelMapperTMService {

  constructor() { }

  mapAffiliate(affiliateTO: IAffiliateTO, parentName: string): IAffiliate {
    return {
      affiliateId: affiliateTO.affiliateId,
      firstName: affiliateTO.firstName,
      lastName: affiliateTO.lastName,
      parentId: affiliateTO.parentId,
      email: affiliateTO.email,
      address: affiliateTO.address,
      phone: affiliateTO.phone,
      isDeleted: affiliateTO.deleted,
      birthDate: affiliateTO.birthDate ? new Date(affiliateTO.birthDate.replace('Z', '') + 'Z') : null,
      dateCreated: affiliateTO.dateCreated ? new Date(affiliateTO.dateCreated.replace('Z', '') + 'Z') : null,
      dateUpdated: affiliateTO.dateUpdated ? new Date(affiliateTO.dateUpdated.replace('Z', '') + 'Z') : null,
      affiliateRole: affiliateTO.affiliateRole,
      identityNumber: affiliateTO.identityNumber,
      city: affiliateTO.city,
      state: affiliateTO.state,
      gender: affiliateTO.gender,
      username: affiliateTO.username,
      workInShopId: affiliateTO.workInShopId,
      shops: affiliateTO.shops ? affiliateTO.shops : [],
      currentBalance: affiliateTO.currentBalance,
      aCommissionSettingId: affiliateTO.aCommissionSettingId,
      aBonusSettingId: affiliateTO.aBonusSettingId,
      aPowerBonusSettingId: affiliateTO.aPowerBonusSettingId,
      parentName,
      affiliateSettingId: affiliateTO.affiliateSettingId,
      subAffiliates: [],
      isUsernameChanged: false
        };
  }

  mapAffiliateTO(affiliate: IAffiliate): IAffiliateTO {
    return {
      affiliateId: affiliate.affiliateId,
      firstName: affiliate.firstName,
      lastName: affiliate.lastName,
      parentId: affiliate.parentId,
      email: affiliate.email,
      address: affiliate.address,
      phone: affiliate.phone,
      deleted: affiliate.isDeleted,
      birthDate: affiliate.birthDate ? affiliate.birthDate.toISOString().replace('Z', '') : null,
      dateCreated: affiliate.dateCreated ? affiliate.dateCreated.toISOString().replace('Z', '') : new Date().toISOString().replace('Z', ''),
      dateUpdated: affiliate.dateUpdated ? affiliate.dateUpdated.toISOString().replace('Z', '') : new Date().toISOString().replace('Z', ''),
      affiliateRole: affiliate.affiliateRole,
      identityNumber: affiliate.identityNumber,
      city: affiliate.city,
      state: affiliate.state,
      gender: affiliate.gender,
      username: affiliate.username,
      workInShopId: affiliate.workInShopId,
      shops: affiliate.shops ? affiliate.shops : [],
      currentBalance: affiliate.currentBalance,
      aCommissionSettingId: affiliate.aCommissionSettingId,
      aBonusSettingId: affiliate.aBonusSettingId,
      aPowerBonusSettingId: affiliate.aPowerBonusSettingId,
      affiliateSettingId: affiliate.affiliateSettingId,
      isUsernameChanged:  affiliate.isUsernameChanged
        };
  }

  mapPlayedTicket(daTicket: IAffiliateTicketDA, agent: string = '', cashier: string = ''): IAffiliatePlayedTicket {
    return {
      id: daTicket.id,
      ticketNumber: daTicket.externalTicketId,
      affiliateId: daTicket.affiliateId,
      cashier,
      agent,
      ticketStatus: daTicket.aTicketStatus,
      stake: daTicket.stake,
      winAmount: daTicket.winAmount,
      dateCreated: new Date(daTicket.dateCreated.replace('Z', '') + 'Z'),
      dateUpdated: new Date(daTicket.dateUpdated.replace('Z', '') + 'Z'),
      ticketType: daTicket.aTicketType,
      shopId: daTicket.shopId,
      itemsNumber: daTicket.itemsNumber,
      betTicketStatus: this.mapAffTicketStatusToBetTikcetStatus(daTicket.aTicketStatus),
      ticketEventsType: daTicket.aTicketEventsType,
      playedFromIp: daTicket.registerIpAddress
    };
  }

  mapAffTicketStatusToBetTikcetStatus(betTicketStatus: DATicketStatus): IPlayedTicketState {
    switch (betTicketStatus) {
      case DATicketStatus.Reserve:
        return {
          name: TicketStatus[TicketStatus.Error],
          code: TicketStatus.Error
        };
      case DATicketStatus.Return:
        return {
          name: TicketStatus[TicketStatus.CustomerCancelled],
          code: TicketStatus.CustomerCancelled
        };
      case DATicketStatus.Open:
        return {
          name: TicketStatus[TicketStatus.Pending],
          code: TicketStatus.Pending
        };
      case DATicketStatus.Void:
        return {
          name: TicketStatus[TicketStatus.Void],
          code: TicketStatus.Void
        };
      case DATicketStatus.Storno:
        return {
          name: TicketStatus[TicketStatus.Storno],
          code: TicketStatus.Storno
        };
      case DATicketStatus.Won:
        return {
          name: TicketStatus[TicketStatus.Won],
          code: TicketStatus.Won
        };
      case DATicketStatus.Lost:
        return {
          name: TicketStatus[TicketStatus.Failed],
          code: TicketStatus.Failed
        };
      case DATicketStatus.CashOut:
        return {
          name: TicketStatus[TicketStatus.CashOut],
          code: TicketStatus.CashOut
        };
      case DATicketStatus.CashBack:
        return {
          name: TicketStatus[TicketStatus.CashBack],
          code: TicketStatus.CashBack
        };
      case DATicketStatus.Paid:
        return {
          name: TicketStatus[TicketStatus.Paid],
          code: TicketStatus.Paid
        };
      case DATicketStatus.CashBackPaid:
        return {
          name: TicketStatus[TicketStatus.CashBackPaid],
          code: TicketStatus.CashBackPaid
        };
      case DATicketStatus.VoidPaid:
        return {
          name: TicketStatus[TicketStatus.VoidPaid],
          code: TicketStatus.VoidPaid
        };

      case DATicketStatus.Expired:
        return {
          name: TicketStatus[TicketStatus.Expired],
          code: TicketStatus.Expired
        };
      default:
        return {
          name: TicketStatus[TicketStatus.Error],
          code: TicketStatus.Error
        };
    }
  }

  mapBank(bankTo: IBankTO): IBank {
    return {
      name: bankTo.name,
      slug: bankTo.slug,
      code: bankTo.code,
      longCode: bankTo.longCode,
      payWithBank: bankTo.payWithBank,
      active: bankTo.active,
      country: bankTo.country,
      currency: bankTo.currency,
      type: bankTo.type,
      id: bankTo.id,
      createdAt: bankTo.createdAt,
      updatedAt: bankTo.updatedAt
    };
  }

  mapCommissionSetting(commissionSetting: ICommissionSettingTO): ICommissionSetting {

    return {
      id: commissionSetting.id,
      name: commissionSetting.name,
      dateUpdated: commissionSetting.dateUpdated,
      isSelected: false,
      commissionSettingItems: commissionSetting.commissionSettingItems ? commissionSetting.commissionSettingItems : null,
      excludeItemsWithLowerOdd: commissionSetting.excludeItemsWithLowerOdd,
      minimumOdd: commissionSetting.minimumOdd
    };
  }

  mapCommissionReport(commissionReportTo: ICommissionReportTO): ICommissionReport {
    return {
      commissionReportId: commissionReportTo.commissionReportId,
      commissionReportName: this.getReportNameByEnum(commissionReportTo.commissionReportType) + ' ' + this.getTicketNameByEnum(commissionReportTo.ticketType),
      commissionReportType: commissionReportTo.commissionReportType,
      ticketType: commissionReportTo.ticketType,
      settledBets: commissionReportTo.settledBets,
      stake: commissionReportTo.stake,
      winnings: commissionReportTo.winnings,
      grossProfit: commissionReportTo.grossProfit,
      tickets: commissionReportTo.tickets,
      commission: commissionReportTo.commission,
      isExpanded: false
    };
  }

  getReportNameByEnum(commissionReportType: CommissionReportType) {
    switch (commissionReportType) {
      case CommissionReportType.multipleBets: {
        return 'Multiple Bets';
      }
      case CommissionReportType.single: {
        return 'Single';
      }
      default: return '';
    }
  }

  getTicketNameByEnum(commissionReportType: TicketTypeTM) {
    switch (commissionReportType) {
      case TicketTypeTM.live: {
        return 'Live';
      }
      case TicketTypeTM.preMatch: {
        return 'Prematch';
      }
      case TicketTypeTM.mix: {
        return 'Mix';
      }
      default: return '';
    }
  }
  mapCommissionSettingItem(commissionSettingItem: ICommissionSettingItemTO): ICommissionSettingItem {
    return {
      id: commissionSettingItem.id,
      aCommissionSettingId: commissionSettingItem.aCommissionSettingId,
      fromItems: commissionSettingItem.fromItems,
      toItems: commissionSettingItem.toItems,
      percentage: commissionSettingItem.percentage,
      dateUpdated: commissionSettingItem.dateUpdated,
    };
  }
  mapTransaction(transactionTO: ITransactionTO): ITransaction {
    return {
      id: transactionTO.id,
      date: new Date(transactionTO.dateCreated.replace('Z', '') + 'Z'),
      description: transactionTO.aTransactionDescription,
      ticketId: transactionTO.aTicketId,
      type: transactionTO.aTransactionType,
      balance: 0,
      affiliateId: transactionTO.affiliateId,
      amount: transactionTO.amount,
      info: transactionTO.info
    };
  }

  mapAffiliateSession(sessionTO: IAffiliateSessionTO): IAffiliateSession {
    // let duration = '';
    // const expiresDate = new Date(sessionTO.expires.replace('Z', '') + 'Z');
    // const startDate = new Date(sessionTO.dateStart.replace('Z', '') + 'Z');

    // let diffTime = Math.abs(startDate.valueOf() - (!sessionTO.isActive ? expiresDate.valueOf() : new Date().valueOf()));
    // const differenceHour = Math.floor(diffTime / 3600000);
    // diffTime -= differenceHour * 3600000;
    // const differenceMin = Math.floor(diffTime / 60000);
    // diffTime -= differenceMin * 60000;
    // const differenceSec = Math.floor(diffTime / 1000);
    // duration = `${differenceHour}:${differenceMin}:${differenceSec}`;

    // return {
    //   startDate,
    //   endDate: sessionTO.isActive ? null : expiresDate,
    //   createdByIp: sessionTO.createdByIp,
    //   isActive: sessionTO.isActive,
    //   sessionId: sessionTO.sessionId,
    //   expiresDate,
    //   duration
    // };
    return {
      dateTime: new Date(sessionTO.dateTime.replace('Z', '') + 'Z'),
      createdByIp: sessionTO.createdByIp,
      sessionId: sessionTO.sessionId,
      sessionHistoryType: sessionTO.sessionHistoryType
    };
  }

  mapCommissionEstimateReport(commissionEstimateReportTO: ICommissionEstimateReportTO): ICommissionEstimateReport {
    const reporsRet = Object.values(commissionEstimateReportTO.daCommissionEstimateReportItems);
    return {
      commissionEstimateReportId: commissionEstimateReportTO.commissionEstimateReportId,
      date: commissionEstimateReportTO.date,
      ticketCount: commissionEstimateReportTO.ticketCount,
      commissionEstimate: commissionEstimateReportTO.commissionEstimate,
      stake: commissionEstimateReportTO.stake,
      daCommissionEstimateReportItems: reporsRet.map(rep => this.mapCommissionEstimateReportItem(rep)),
      isExpanded: false
    };
  }

  mapCommissionEstimateReportItem(commissionEstimateReportItemTO: ICommissionEstimateReportItemTO): ICommissionEstimateReportItem {
    return {
      commissionEstimateReportItemId: commissionEstimateReportItemTO.commissionEstimateReportItemId,
      date: commissionEstimateReportItemTO.date,
      ticketCount: commissionEstimateReportItemTO.ticketCount,
      numberOfSelectionsFrom: commissionEstimateReportItemTO.numberOfSelectionsFrom,
      numberOfSelectionsTo: commissionEstimateReportItemTO.numberOfSelectionsTo,
      stake: commissionEstimateReportItemTO.stake,
      commissionPercentage: commissionEstimateReportItemTO.commissionPercentage,
      commissionEstimate: commissionEstimateReportItemTO.commissionEstimate,
      tickets: commissionEstimateReportItemTO.tickets,
      isExpanded: false
    };
  }

  mapAffiliateBonusSettingDA(bonusSetting: IAffiliateBonusSetting): IBonusSettingDA {
    return {
      id: bonusSetting.id ? bonusSetting.id : 0,
      name: bonusSetting.name,
      dateUpdated: bonusSetting.dateUpdated.toISOString().replace('Z', ''),
      bonusPercentage: bonusSetting.bonusPercentage,
      minimumGrossProfit: bonusSetting.minimumGrossProfit,
      minimumTotalStake: bonusSetting.minimumTotalStake,
    };
  }

  mapAffiliateBonusSetting(bonusSettingDa: IBonusSettingDA): IAffiliateBonusSetting {
    return {
      id: bonusSettingDa.id,
      name: bonusSettingDa.name,
      dateUpdated: new Date(bonusSettingDa.dateUpdated.replace('Z', '') + 'Z'),
      bonusPercentage: bonusSettingDa.bonusPercentage,
      minimumGrossProfit: bonusSettingDa.minimumGrossProfit,
      minimumTotalStake: bonusSettingDa.minimumTotalStake,
    };
  }

  mapPowerBonusSettingItems(powerBonusSettingItemsDa: { [id: number]: IPowerBonusSettingItemDA }): {
    powerBonusSettingItems: { [id: number]: IPowerBonusSettingItem };
    powerBonusSettingItemsList: IPowerBonusSettingItem[];
  } {
    let powerBonusSettingItemsListDa: IPowerBonusSettingItemDA[] = [];
    if (powerBonusSettingItemsDa) {
      powerBonusSettingItemsListDa = Object.entries(powerBonusSettingItemsDa).map(([k, v]) => v).sort((a, b) => a.weeklyStakeTarget - b.weeklyStakeTarget);
    }

    const powerBonusSettingItems: { [id: number]: IPowerBonusSettingItem } = {};
    const powerBonusSettingItemsList: IPowerBonusSettingItem[] = [];
    let i = 0;
    for (const itemDa of powerBonusSettingItemsListDa) {
      i++;
      const item: IPowerBonusSettingItem = this.mapPowerBonusSettingItem(itemDa, i);
      powerBonusSettingItemsList.push(item);
      powerBonusSettingItems[item.id] = item;
    }

    return { powerBonusSettingItems, powerBonusSettingItemsList };
  }

  mapPowerBonusSettingItem(powerBonusSettingItemDa: IPowerBonusSettingItemDA, level: number): IPowerBonusSettingItem {
    return {
      updateType: PowerBonusSettingItemUpdateType.none,
      id: powerBonusSettingItemDa.id,
      powerBonusSettingId: powerBonusSettingItemDa.aPowerBonusSettingId,
      levelNumber: level,
      dailyBetsTarget: powerBonusSettingItemDa.dailyBetsTarget,
      tradedDays: powerBonusSettingItemDa.tradedDays,
      dateUpdated: new Date(powerBonusSettingItemDa.dateUpdated.replace('Z', '') + 'Z'),
      weeklyStakeTarget: powerBonusSettingItemDa.weeklyStakeTarget,
      bonusEligible: powerBonusSettingItemDa.bonusEligible
    };
  }

  mapPowerBonusSettingItemDA(powerBonusSettingItem: IPowerBonusSettingItem): IPowerBonusSettingItemDA {
    return {
      id: powerBonusSettingItem.id ? powerBonusSettingItem.id : 0,
      aPowerBonusSettingId: powerBonusSettingItem.powerBonusSettingId,
      dailyBetsTarget: powerBonusSettingItem.dailyBetsTarget,
      tradedDays: powerBonusSettingItem.tradedDays,
      dateUpdated: powerBonusSettingItem.dateUpdated.toISOString().replace('Z', ''),
      weeklyStakeTarget: powerBonusSettingItem.weeklyStakeTarget,
      bonusEligible: powerBonusSettingItem.bonusEligible
    };
  }

  mapPowerBonusSetting(powerBonusSettingDA: IPowerBonusSettingDA): IPowerBonusSetting {
    let powerBonusSettingItemsListDa: IPowerBonusSettingItemDA[] = [];
    if (powerBonusSettingDA.powerBonusSettingItems) {
      powerBonusSettingItemsListDa = Object.entries(powerBonusSettingDA.powerBonusSettingItems).map(([k, v]) => v).sort((a, b) => a.weeklyStakeTarget - b.weeklyStakeTarget);

    }

    const powerBonus: IPowerBonusSetting = {
      id: powerBonusSettingDA.id,
      name: powerBonusSettingDA.name,
      dateCreated: new Date(powerBonusSettingDA.dateCreated.replace('Z', '') + 'Z'),
      powerBonusSettingItems: {},
      powerBonusSettingItemsList: [],
      isSelected: false
    };

    let i = 0;
    for (const itemDa of powerBonusSettingItemsListDa) {
      i++;
      const item: IPowerBonusSettingItem = this.mapPowerBonusSettingItem(itemDa, i);
      powerBonus.powerBonusSettingItemsList.push(item);
      powerBonus.powerBonusSettingItems[item.id] = item;
    }

    return powerBonus;
  }

  mapPowerBonusSettingDA(powerBonusSetting: IPowerBonusSetting): IPowerBonusSettingDA {
    const powerBonusSettingItems: { [id: number]: IPowerBonusSettingItemDA } = {};

    for (const pbsi of powerBonusSetting.powerBonusSettingItemsList) {
      powerBonusSettingItems[pbsi.id] = this.mapPowerBonusSettingItemDA(pbsi);
    }
    return {
      id: powerBonusSetting.id ? powerBonusSetting.id : 0,
      name: powerBonusSetting.name,
      dateCreated: powerBonusSetting.dateCreated ? powerBonusSetting.dateCreated.toISOString().replace('Z', '') : null,
      powerBonusSettingItems
    };
  }

  mapPowerBonusReportItem(powerBonusReportItemDa: IPowerBonusReportItemDA, level: number, dayReports: IPowerBonusDayReport[], weeklyStake: number): IPowerBonusReportItem {
    // calculate total percent
    let daysRequirmentsMetCount = dayReports.filter(dr => dr.dailyBets >= powerBonusReportItemDa.dailyBetsTarget).length;
    if (daysRequirmentsMetCount > powerBonusReportItemDa.dailyBetsTarget) {
      daysRequirmentsMetCount = powerBonusReportItemDa.dailyBetsTarget;
    }
    return {
      requirementsMet: powerBonusReportItemDa.requirementsMet,
      dailyBetsTarget: powerBonusReportItemDa.dailyBetsTarget,
      tradedDays: powerBonusReportItemDa.tradedDays,
      weeklyStakeTarget: powerBonusReportItemDa.weeklyStakeTarget,
      level,
      bonusEligible: powerBonusReportItemDa.bonusEligible,
      totalPercent: (daysRequirmentsMetCount + (weeklyStake >= powerBonusReportItemDa.weeklyStakeTarget ? 1 : 0)) / (powerBonusReportItemDa.tradedDays + 1),
      stakePercent: weeklyStake >= powerBonusReportItemDa.weeklyStakeTarget ? 1 : weeklyStake / powerBonusReportItemDa.weeklyStakeTarget
    };
  }

  mapPowerBonusDayReport(powerBonusDayReportDa: IPowerBonusDayDA): IPowerBonusDayReport {
    return {
      date: new Date(powerBonusDayReportDa.date.replace('Z', '') + 'Z'),
      dayOfWeek: powerBonusDayReportDa.dayOfWeek,
      dailyBets: powerBonusDayReportDa.dailyBets,
      dailyStake: powerBonusDayReportDa.dailyStake,
    };
  }

  mapPowerBonusWeeklyReport(powerBonusWeeklyDA: IWeeklyPowerBonusDA): IWeeklyPowerBonus {
    powerBonusWeeklyDA.dAPowerBonusSettingResponseItems = powerBonusWeeklyDA.dAPowerBonusSettingResponseItems.sort((a, b) => a.weeklyStakeTarget - b.weeklyStakeTarget);
    powerBonusWeeklyDA.dAPowerBonusDayResponseItems = powerBonusWeeklyDA.dAPowerBonusDayResponseItems.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
    // first elem to end
    const [first, ...rest] = powerBonusWeeklyDA.dAPowerBonusDayResponseItems;
    powerBonusWeeklyDA.dAPowerBonusDayResponseItems = [...rest, first];

    let ernedBonus = 0;

    let i = 1;
    const powerBonusDayResponseItems = powerBonusWeeklyDA.dAPowerBonusDayResponseItems.map(pbsi => this.mapPowerBonusDayReport(pbsi));
    return {
      powerBonusDayReports: powerBonusDayResponseItems,
      powerBonusReportItems: powerBonusWeeklyDA.dAPowerBonusSettingResponseItems.map(pbsi => {
        if (pbsi.requirementsMet) {
          ernedBonus += pbsi.bonusEligible;
        }
        return this.mapPowerBonusReportItem(pbsi, i++, powerBonusDayResponseItems, powerBonusWeeklyDA.weeklyStake);
      }),
      weeklyStake: powerBonusWeeklyDA.weeklyStake,
      bonusEarned: ernedBonus
    };
  }

  mapMessage(messageDa: IMessageDA): IMessage {
    let seenByCount = 0;
    return {
      messageId: messageDa.messageId,
      recipietMessageId: messageDa.id,
      fromAffiliateId: messageDa.fromAffiliateId,
      messageStatusAndRecipientIds: messageDa.daMessageStatusTypeAndToAffiliateIdPairs.map(d => {
        if (d.messageStatusType !== MessageStatus.unseen) {
          seenByCount++;
        }
        return { toAffiliateId: d.toAffiliateId, status: d.messageStatusType };
      }),
      fromAffiliateName: messageDa.fromAffiliateName,
      subject: messageDa.subject,
      message: messageDa.message,
      dateCreated: new Date(messageDa.dateCreated.replace('Z', '') + 'Z'),
      deleted: messageDa.deleted,
      seenByCount
    };

  }

  mapMessageDA(message: IMessage): IMessageDA {
    return {
      messageId: message.messageId,
      fromAffiliateId: message.fromAffiliateId,
      fromAffiliateName: message.fromAffiliateName,
      daMessageStatusTypeAndToAffiliateIdPairs: message.messageStatusAndRecipientIds.map(d => ({ toAffiliateId: d.toAffiliateId, messageStatusType: d.status, })),
      subject: message.subject,
      message: message.message,
      dateCreated: message.dateCreated.toISOString().replace('Z', ''),
      deleted: message.deleted,
      id: message.recipietMessageId
    };
  }

  mapMessagesForPage(messagesForPageDA: IMessagesForPageDA, pageNumber: number): IMessagesForPage {
    return {
      pageNumber,
      totalCount: messagesForPageDA.totalCount,
      messages: messagesForPageDA.daMessageResponses.map(m => this.mapMessage(m))
    };
  }

  mapSalesReportsByAffiliate(reportDA: ISalesReportsByAffiliateDA): ISalesReportsByAffiliate {
    const salesByAffiliate: ISalesReportsByAffiliate =      {
      affiliateId: reportDA.affiliateId,
      firstName: reportDA.firstName,
      lastName: reportDA.lastName,
      reports: [],
      totalBets: 0,
      totalRunningBets: 0,
      totalSettledBets: 0,
      totalStake: 0,
      totalWinnings: 0,
      totalOpenStakes: 0,
      totalPaidAmount: 0,
      totalWonPaid: 0,
      isExpanded: false
    };

    for (const key in reportDA.report) {
      if (Object.prototype.hasOwnProperty.call(reportDA.report, key)) {
        const report = this.mapSalesReport(reportDA.report[key]);
        salesByAffiliate.reports.push(report);
        salesByAffiliate.totalBets += report.totalBets;
        salesByAffiliate.totalRunningBets += report.runningBets;
        salesByAffiliate.totalSettledBets += report.settledBets;
        salesByAffiliate.totalStake += report.stake;
        salesByAffiliate.totalWinnings += report.winnings;
        salesByAffiliate.totalOpenStakes += report.openStakes;
        salesByAffiliate.totalPaidAmount += report.paidAmount;
        salesByAffiliate.totalWonPaid += report.winnings + report.paidAmount;
      }
    }

    return salesByAffiliate;
  }

  mapPaidReportsByAffiliate(reportDA: IPaidReportsByAffiliateDA): IPaidReportsByAffiliate {
    const paidByAffiliate: IPaidReportsByAffiliate =      {
      affiliateId: reportDA.affiliateId,
      firstName: reportDA.firstName,
      lastName: reportDA.lastName,
      reports: [],
      totalBets: 0,
      // totalRunningBets: 0,
      totalSettledBets: 0,
      totalStake: 0,
      // totalWinnings: 0,
      // totalOpenStakes: 0,
      totalPaidAmount: 0,
      totalWonPaid: 0,
      isExpanded: false
    };

    for (const key in reportDA.report) {
      if (Object.prototype.hasOwnProperty.call(reportDA.report, key)) {
        const report = this.mapPaidReport(reportDA.report[key]);
        paidByAffiliate.reports.push(report);
        paidByAffiliate.totalBets += report.totalBets;
        // paidByAffiliate.totalRunningBets += report.runningBets;
        paidByAffiliate.totalSettledBets += report.settledBets;
        paidByAffiliate.totalStake += report.stake;
        // paidByAffiliate.totalWinnings += report.winnings;
        // paidByAffiliate.totalOpenStakes += report.openStakes;
        paidByAffiliate.totalPaidAmount += report.paidAmount;
        paidByAffiliate.totalWonPaid += report.paidAmount;
      }
    }

    return paidByAffiliate;
  }

  mapSalesReport(reportDA: ISalesReportDA): ISalesReport {
    let reportName = '';

    if (reportDA.commissionReportType === CommissionReportType.single) {
      if (reportDA.ticketType === TicketTypeTM.preMatch) {
        reportName = 'Prematch Single Bet';
      } else if (reportDA.ticketType === TicketTypeTM.live) {
        reportName = 'Live Single Bet';
      }
    } else {
      if (reportDA.ticketType === TicketTypeTM.preMatch) {
        reportName = 'Prematch Multi Bets';
      } else if (reportDA.ticketType === TicketTypeTM.live) {
        reportName = 'Live Multi Bets';
      } else {
        reportName = 'Mix Multi Bets';
      }
    }

    return {
      reportName,
      saleReportId: reportDA.saleReportId,
      commissionReportType: reportDA.commissionReportType,
      ticketType: reportDA.ticketType,
      settledBets: reportDA.settledBets,
      stake: reportDA.stake,
      winnings: reportDA.winnings,
      openStakes: reportDA.openStakes,
      runningBets: reportDA.runningBets,
      totalBets: reportDA.runningBets + reportDA.settledBets,
      paidAmount: reportDA.paidAmount,
      wonPaid: reportDA.winnings + reportDA.paidAmount
    };
  }

  mapPaidReport(reportDA: IPaidReportDA): IPaidReport {
    let reportName = '';

    if (reportDA.commissionReportType === CommissionReportType.single) {
      if (reportDA.ticketType === TicketTypeTM.preMatch) {
        reportName = 'Prematch Single Bet';
      } else if (reportDA.ticketType === TicketTypeTM.live) {
        reportName = 'Live Single Bet';
      }
    } else {
      if (reportDA.ticketType === TicketTypeTM.preMatch) {
        reportName = 'Prematch Multi Bets';
      } else if (reportDA.ticketType === TicketTypeTM.live) {
        reportName = 'Live Multi Bets';
      } else {
        reportName = 'Mix Multi Bets';
      }
    }

    return {
      reportName,
      paidReportId: reportDA.paidReportId,
      commissionReportType: reportDA.commissionReportType,
      ticketType: reportDA.ticketType,
      settledBets: reportDA.settledBets,
      stake: reportDA.stake,
      // winnings: reportDA.winnings,
      // openStakes: reportDA.openStakes,
      // runningBets: reportDA.runningBets,
      totalBets: reportDA.settledBets,
      paidAmount: reportDA.paidAmount,
      wonPaid: reportDA.paidAmount
    };
  }

  mapShopReport(reportDA: IShopReportDA): IShopReport {
    // let reportName = '';
    return {
      dateCreated: reportDA.dateCreated,
      stakes: reportDA.stakes,
      taxStakes: reportDA.taxStakes,
      taxWin: reportDA.taxWin,
      paid: reportDA.paid,
      storno: reportDA.storno,
      numberOfStakes: reportDA.numberOfStakes,
      numberOfPaid: reportDA.numberOfPaid,
      numberOfStorno: reportDA.numberOfStorno,
      total: reportDA.stakes - reportDA.paid - reportDA.storno
    };
  }

  mapAffiliateSettingDA(affiliateSetting: IAffiliateSetting): IAffiliateSettingDA {
    return {
      id: affiliateSetting.id ? affiliateSetting.id : 0,
      name: affiliateSetting.name,
      ticketValidDays: affiliateSetting.ticketValidDays,
      aCrossBookingType: affiliateSetting.crossBookingType,
      dateUpdated: affiliateSetting.dateUpdated.toISOString().replace('Z', '')
    };
  }

  mapAffiliateSetting(affiliateSettingDa: IAffiliateSettingDA): IAffiliateSetting {
    return {
      id: affiliateSettingDa.id,
      name: affiliateSettingDa.name,
      ticketValidDays: affiliateSettingDa.ticketValidDays,
      crossBookingType: affiliateSettingDa.aCrossBookingType,
      dateUpdated: new Date(affiliateSettingDa.dateUpdated.replace('Z', '') + 'Z'),
    };
  }
}
